__turbopack_context__.v({
  "example": "E2kq4q_example",
  "toolbar": "E2kq4q_toolbar",
});
